import HeaderWithIcons from '@components/app/HeaderWithIcons';
import ImamRezaCompetition from '@components/competitions/levels/imamreza';
import {appConfig} from '@config';
import scopedI18n from '@locale/scoped-i18n';
import {Box, Button, Link, Skeleton, Typography} from '@mui/material';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {I18nextProvider, useTranslation} from 'react-i18next';
import {useLoaderData, useParams, useSearchParams} from 'react-router-dom';
import {ICompetition} from './ICompetitions';

let referrerFrom = document.referrer;
export default function ImamrezaLevelCompetition() {
	const {t} = useTranslation();
	const {'*': refPath} = useParams();
	const referrerCode = refPath?.split('/')[0];
	// const location = useLocation();
	const [queryParameters] = useSearchParams();
	const [referrer] = useState<string>(referrerFrom);
	// const [searchParams] = useSearchParams();
	// const [searchParams, setSearchParams] = useSearchParams();
	const [competition, setCompetition] = useState<ICompetition | undefined>();
	const [referral] = useState<string>(queryParameters.get('referral') as string);
	let competitionObject = useLoaderData() as ICompetition;
	const [lang, setLang] = useState<'fa' | 'ar' | 'en'>('en');
	
	useEffect(() => {
		setCompetition(competitionObject);
	}, []);
	
	// update language of the local instance
	useEffect(() => {
		scopedI18n.changeLanguage(lang);
	}, [lang]);
	const renderAction = (competition: ICompetition) => {
		let status = <Button component={Link} href={competition.winnerLink} className="mx-3">{t('winner_list')}</Button>;
		switch (competition.status) {
			case 'enabled':
				status = <Button component={Link} href={competition.link} className="mx-3">{t('start_competition')}</Button>;
				break;
			case 'remain':
				status = <Typography sx={{color: 'grey.600'}}
				                     className="mx-4">{t('remain_until_start', {day: competition.remainDay})}</Typography>;
		}
		return status;
	};
	
	return (
		<>
			<I18nextProvider i18n={scopedI18n}>
				<HeaderWithIcons title={competition?.name ?? <Skeleton className="w-24"/>} home={false} backUrl={'/'} back={false}/>
				<Box className="flex flex-col gap-y-2"
				     sx={{
					     fontFamily: 'AriaWeb',
					     // fontWeight: 500,
					     borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.100' : 'background.paper',
					     bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.A200' : 'grey.700'
				     }}
				>
					{
						competition?.id == 3 && (
							<>
								<ImamRezaCompetition competition={competition} referrer={referrer} referrerCode={referrerCode}/>
							</>
						)
					}
				</Box>
			</I18nextProvider>
		</>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function competitionImamrezaLoader(data: loader) {
	const res = await axios({
		// @ts-ignore
		url: `${appConfig.competition2.url}competition/2`,
		method: 'GET'
	});
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data.error;
	}
}

// export async function competitionImamrezaLoader({params}: LoaderFunctionArgs) {
// 	const {ref} = params;
//
// 	const res = await axios({
// 		url: `${appConfig.competition2.url}competition/2`,
// 		method: 'POST',
// 		data: {
// 			referral_code: ref
// 		}
// 	});
//
// 	if (res.data.success) {
// 		return res.data.result;
// 	} else {
// 		return res.data;
// 		// throw new Error(res.data.error || 'Failed to fetch result');
// 	}
// }
